import { makeMultiSearch, makeSearch } from "../../UI/Search/Search";
import EthnicityService from "../../../Services/Ethnicity.service";
const makeSearchArgs = {
    loadOptions: (search) => EthnicityService.searchAll(search),
    label: "name",
    value: "id",
};
export const EthnicitySearch = makeSearch(makeSearchArgs);
export const EthnicityMultiSearch = makeMultiSearch(Object.assign({}, makeSearchArgs));
